export default function getFraction(average: number | undefined | null, target: number, roundTo: number = 0.1): number {
	if (!average) {
		return 0;
	}
	if (average >= target) {
		return 1.0;
	}

	const fraction = average - Math.floor(target - 1);
	const rounded = Math.round(fraction / roundTo) * roundTo;

	// avoid floating point artifacts (e.g. 0.30000000000000004) by rounding to the same
	// number of decimals as roundTo itself
	const decimals = roundTo.toString().split(".")[1]?.length ?? 0;

	return Math.max(0, parseFloat(rounded.toFixed(decimals)));
}